import { Navigate, Route, Routes } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import Home from './pages/Home';
import Layout from './components/Layout';
import Aos from 'aos';
import 'aos/dist/aos.css';
import React, { useEffect } from 'react';
import Login from "./pages/login";
import Device from "./pages/device";
import Terms from "./pages/terms";
import Abouts from "./pages/abouts";

function App() {
  useEffect(() => {
    Aos.init({
      once: true,
    });
  }, []);

  const isTokenValid = () => {
    try {
      const token = localStorage.getItem("authTokenZplayer");
      if (!token) return false;
        const device = JSON.parse(localStorage.getItem("deviceZplayer"));
        if (!device || !device.id|| !device.mac) return false;

      // Decode the token
      const decodedToken = jwtDecode(token);

      // Check if the token is expired
      const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
      return decodedToken.exp > currentTime; // Token is valid if expiration time is in the future
    } catch (error) {
      console.error("Invalid token:", error);
      return false; // If decoding fails, the token is invalid
    }
  };
  const ProtectedRoute = ({ children }) => {
    return isTokenValid() ? children : <Navigate to="/login" replace />;
  };

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
      </Route>
      {/* Device Route */}
      <Route
          path="/device"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
      >
        <Route index element={<Device />} />
      </Route>
      <Route path="/login" element={<Layout />}>
        <Route index element={<Login />} />
      </Route>
      <Route path="/sign-in" element={<Layout />}>
        <Route index element={<Login />} />
      </Route>
      <Route path="/terms&conditions" element={<Layout />}>
        <Route index element={<Terms />} />
      </Route>
      <Route path="/abouts" element={<Layout />}>
        <Route index element={<Abouts />} />
      </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
